import { ApiClient } from '@webapp/core/services/ApiClient'
import { CommentRepository } from './CommentRepository'

export const commentRepository = new CommentRepository({
  httpClient: ApiClient,
})
